import { ProfileEdit } from '@entities/User'

import { LogoutButton } from '@features/auth'


import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function ProfilePage () {
  return (
    <div className={styles.root}>
      <Wrapper className={styles.wrapper}>
        <ProfileEdit />
      </Wrapper>
      <Wrapper className={styles.wrapper}>
        <LogoutButton />
      </Wrapper>
    </div>
  )
}
